// Single source of truth for Redux Toolkit's serializableCheck middleware
// configuration. Imported by both the production store and the test mock store
// so the warnings the user sees in tests match the warnings that would fire in
// production — and the ignored paths stay in sync as new modals/actions land.

export const serializableCheckConfig = {
  ignoredActionPaths: [
    'payload.extraProps.modalDescription',
    'payload.extraProps.onCancel',
    'payload.extraProps.onSuccess',
    'payload.extraProps.onMutated',
    'payload.extraProps.onDeleted',
    'payload.extraProps.modalData',
    'payload.extraProps.customComponent',
    'meta.arg',
    // RTK's createAsyncThunk returns objects with an `unwrap` method; ignore so
    // tests that re-dispatch those results don't trip the invariant check.
    'unwrap',
    /payload\.data\.\d+\.file/,
    /payload\.data\.\d+\.thumbnailFile/,
    /payload\.data\.\d+\.current_quote_reference\.quote_tasks\.\d+\.media\.\d+\.file/,
    /payload\.data\.media\.\d+\.file/,
    /payload\.data\.media\.\d+\.thumbnailFile/,
    'work-order/uploadMediaThumbnail/pending',
    'work-order/uploadMediaThumbnail/fulfilled',
    'work-order/uploadMediaThumbnail/rejected',
  ],
  ignoredPaths: [
    /modals\.[\w-]+\.extraProps\.modalDescription/,
    /modals\.[\w-]+\.extraProps\.onCancel/,
    /modals\.[\w-]+\.extraProps\.onSuccess/,
    /modals\.[\w-]+\.extraProps\.onMutated/,
    /modals\.[\w-]+\.extraProps\.onDeleted/,
    /modals\.[\w-]+\.extraProps\.modalData/,
    /modals\.[\w-]+\.extraProps\.customComponent/,
    /work_orders\.source\.[\w-]+\.media\.\d+\.file/,
    /work_orders\.source\.[\w-]+\.media\.\d+\.thumbnailFile/,
    /work_orders\.source\.[\w-]+\.current_quote_reference\.quote_tasks\.\d+\.media\.\d+\.file/,
    /work_orders\.source\.[\w-]+\.work_order_tasks.\d+\.appointments.\d+\.media.\d+\.file/,
    /work_orders\.source\.[\w-]+\.work_order_tasks.\d+\.appointments.\d+\.media.\d+\.thumbnailFile/,
    'vendor.work-orders.source.media',
  ],
};
